/**
 * Copy for the static landing hero: one slide, the heading, and two
 * actions, plus the helper that moves focus to the sample block.
 *
 * The question card’s text is not copied here. The card reads it from
 * sampleQuestion.ts so the hero and the sample block cannot drift.
 */

export const HERO_LABEL = "Destaques";

export const SLIDE_COUNT = 3;

export function slideLabel(index: 1 | 2 | 3): string {
  return `Slide ${index} de ${SLIDE_COUNT}`;
}

export const HEADLINE_LINES = ["Treine para o seu", "concurso resolvendo"] as const;

export const HEADLINE_ACCENT = "questões.";

/**
 * Slide 1 kicker, the same at every width. Also the first line of the
 * question card.
 */
export const SLIDE_1_KICKER = "QUESTÃO DE EXEMPLO · SEM CADASTRO";

export const SLIDE_1_SUBTITLE = "Experimente uma questão de exemplo, sem criar conta.";

/** Primary hero action. Focuses the example-question title. */
export const ACTION_TRY_QUESTION = "Testar uma questão";

export const ACTION_SEE_PLANS = "Ver planos";

/** In-page sample. A hash link keeps the path at `/`. */
export const HREF_AMOSTRA = "#amostra";

/** Heading inside `#amostra`. Sample entries move focus here. */
export const SAMPLE_HEADING_ID = "amostra-heading";

/** Existing plans page. This is a route change, not a scroll. */
export const HREF_PLANOS = "/planos";

/**
 * Scrolls the sample block into view and moves focus to its heading.
 *
 * The hero primary "Testar uma questão" calls this, and so do the other
 * sample entries that still point at the example question. When the block
 * is not mounted, the hash is left to the browser.
 */
export function activateSampleEntry(event: { preventDefault(): void }): void {
  if (typeof document === "undefined") {
    return;
  }
  const section = document.getElementById("amostra");
  const heading = document.getElementById(SAMPLE_HEADING_ID);
  if (!section || !heading) {
    return;
  }
  event.preventDefault();
  section.scrollIntoView({ block: "start" });
  heading.focus({ preventScroll: true });
  const nextUrl = `${window.location.pathname}${HREF_AMOSTRA}`;
  if (`${window.location.pathname}${window.location.hash}` !== nextUrl) {
    window.history.pushState(null, "", nextUrl);
  }
}
